import request from '../../utils/request'
import industrySelect from "@/components/runner/IndustrySelect.vue";

// 生成代码
export function generate (data) {
  return request.post('/runner/generate', data)
}

// 保存生成参数
export function saveGenerateConfig (data) {
  return request.post('/runner/config/save', data)
}

// 随机获取参数
export function randomParameters (templateId) {
  return request.get(`/runner/parameter/random/${templateId}`)
}

// 随机获取模块
export function randomModules (industryId) {
  return request.get(`/runner/module/random/${industryId}`)
}

// 查询所有行业
export function fetchIndustryList () {
  return request.get('/runner/industry/list')
}

// 查询行业关联模块
export function fetchIndustryModules (industryId) {
  return request.get(`/runner/module/${industryId}`)
}

// 根据关键字匹配行业
export function matchIndustry (keywords) {
  return request.get('/runner/industry/match', {
    params: {
      kwd: keywords
    },
    trim: true
  })
}

// 根据关键字匹配模版
export function matchTemplate (keywords) {
  return request.get('/runner/template/match', {
    params: {
      kwd: keywords
    },
    trim: true
  })
}

// 查询所有行业
export function fetchParameterTypeList (data) {
  return request.post('/runner/parameter/type/list', data)
}
